import type { ExtractPropTypes, PropType } from 'vue'
import type {
  RuleRecord,
  RuleResultSchema,
  RuleUserContentType,
  RulesType,
} from './rules'

export const rulesProps = {
  system: {
    type: String,
    required: true,
  },
  module: {
    type: String,
    default: undefined,
  },
  type: {
    type: String as PropType<RulesType>,
    default: 'system',
  },
  content: {
    type: String as PropType<RuleUserContentType>,
    default: 'boolean',
  },
  modelValue: {
    type: Array as PropType<RuleRecord[]>,
    default: () => [],
  },
  ruleResult: {
    type: Object as PropType<RuleResultSchema>,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
} as const

export type RulesProps = ExtractPropTypes<typeof rulesProps>

export const rulesEmits = {
  'update:modelValue': (records: RuleRecord[]) => Array.isArray(records),
  change: (records: RuleRecord[]) => Array.isArray(records),
  add: (record: RuleRecord) => record != null && typeof record === 'object',
  delete: (records: RuleRecord[]) => Array.isArray(records),
  map: (records: RuleRecord[]) => Array.isArray(records),
}
